import React, { useState } from 'react'
import {
  arrayOf,
  shape,
  string,
  node,
} from 'prop-types'

function Tabs({
  tabs,
  activeTabId = null,
  containerClass = '',
}) {
  const [activeId, setActiveId] = useState(activeTabId || tabs[0].id)

  function changeTab(e, id) {
    e.preventDefault()
    setActiveId(id)
  }

  const tabsList = (
    <ul className="cgt-tabs">
      {tabs.map((tab) => (
        <li key={`cgt-tab-${tab.id}`}>
          <a
            href="#"
            data-name={tab.id}
            onClick={(e) => changeTab(e, tab.id)}
            className={`cgt-tab cgt-tab--medium cgt-legacy-heading-h6 ${tab.id === activeId ? 'cgt-tab--active' : ''}`}
          >
            {tab.title}
          </a>
        </li>
      ))}
    </ul>
  )

  return (
    <div className="cgt-tabs-wrapper">
      {tabsList}
      <div className={`cgt-tab-content ${containerClass}`}>
        {tabs.find(tab => tab.id === activeId).contents}
      </div>
    </div>
  )
}

Tabs.propTypes = {
  tabs: arrayOf(
    shape({
      title: string.isRequired,
      id: string.isRequired,
      contents: node.isRequired,
    })
  ).isRequired,
  activeTabId: string,
  containerClass: string,
}

export default Tabs
